import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Photographer} from '../../../entities/photographer/photographer.entity';
import {getTagIconFromLabel} from '../../../../core/entities/photography/photography-tag.entity';
import {TranslocoPipe} from '@jsverse/transloco';
import {AppImageComponent} from '../../../../core/components/image/image';

@Component({
  selector: 'app-photographer-profile',
  imports: [
    TranslocoPipe,
    AppImageComponent
  ],
  templateUrl: './photographer-profile.html',
  standalone: true,
  styleUrl: './photographer-profile.scss'
})
export class PhotographerProfile {
  @Input() photographer: Photographer|null = null;
  @Output() bookNow = new EventEmitter<void>();

  public openBookNowModal(): void {
    this.bookNow.emit();
  }

  protected readonly getTagIconFromLabel = getTagIconFromLabel;
}
